<template>
  <div class="page-container">
    <header-title @onRefresh="onLoad" has-refresh>
      <template #title>
        <span class="t">
          {{ checked ? 'Open Job List' : 'Closed Job List' }}
        </span>
        <a-switch
          v-model:checked="checked"
          @change="onLoad"
          :loading="loading"
        />
      </template>
    </header-title>
    <div class="table-box" ref="aTableRef">
      <a-table
        :loading="loading"
        size="middle"
        :dataSource="dataSource"
        :columns="columns"
        rowKey="id"
        :pagination="false"
        :rowClassName="
          (record, index) => (index % 2 === 1 ? 'table-striped' : null)
        "
        :scroll="scroll"
      />
    </div>
  </div>
</template>
<script>
  import HeaderTitle from '@/layout/header-title'
  import { getCompletion } from '@/api/supervisor-landing'
  import { throttle, parseTime } from '@/utils'
  export default {
    components: { HeaderTitle },
    data() {
      return {
        checked: false,
        loading: false,
        scroll: { y: 300 },
        dataSource: [],
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: '5%',
          },
          {
            title: 'Job ID',
            dataIndex: 'jobId',
            width: '13%',
          },
          {
            title: 'FG Name',
            dataIndex: 'fgName',
            width: '12%',
          },
          {
            title: 'Region',
            dataIndex: 'currentRegion',
            width: '12%',
          },
          {
            title: 'Req Start',
            dataIndex: 'reqStart',
            width: '12%',
            customRender({ text }) {
              return parseTime(text, '{m}/{d} {h}:{i}')
            },
          },
          {
            title: 'Req End',
            dataIndex: 'reqEnd',
            width: '12%',
            customRender({ text }) {
              return parseTime(text, '{m}/{d} {h}:{i}')
            },
          },
          {
            title: 'Actual Start',
            dataIndex: 'astart',
            width: '12%',
            customRender({ text }) {
              return parseTime(text, '{m}/{d} {h}:{i}')
            },
          },
          {
            title: 'Actual End',
            dataIndex: 'aend',
            width: '12%',
            customRender({ text }) {
              return parseTime(text, '{m}/{d} {h}:{i}')
            },
          },
          {
            title: 'Gap',
            dataIndex: 'gap',
            width: '10%',
          },
        ],
      }
    },
    watch: {},
    computed: {},
    created() {
      this.onLoad()
    },
    mounted() {
      this.setTableScrollH()
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
    },
    methods: {
      setTableScrollH() {
        let top = 88
        if (this.$refs.aTableRef) {
          top = this.$refs.aTableRef.getBoundingClientRect().top
        }
        const wH = window.innerHeight
        this.scroll = { y: wH - (top + 70) }
      },
      async onLoad() {
        this.loading = true
        const { id, uiid } = this.$route.query
        const params = {
          id,
          uiid,
        }
        try {
          const url = this.checked
            ? '/api/dashboard/completion/open'
            : '/api/dashboard/completion'
          const { body } = await getCompletion(url, params)
          this.loading = false
          this.dataSource = body
        } catch (e) {
          this.loading = false
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  .page-container {
    height: calc(100vh - 32px);
    :deep(.ant-select) {
      width: 200px;
    }
    :deep(.ant-table-tbody) {
      .table-striped td {
        background-color: #fbfbfb;
      }
    }
    .tit-box .t {
      min-width: 200px;
      display: inline-block;
    }
  }
</style>
